import TimeSync from 'utils/TimeSync';
import { fromIso9075DateString } from 'utils/dates';

export const TOURNAMENT_STATUS_IN_PROGRESS = 'InProgress';
export const TOURNAMENT_STATUS_UPCOMING = 'Enabled';
export const TOURNAMENT_STATUS_COMPLETED = 'Completed';
export const TOURNAMENT_EVENT_NOTIFY_START = 'notifyStart';
export const TOURNAMENT_EVENT_START = 'start';
export const TOURNAMENT_EVENT_END = 'end';
export const TOURNAMENT_EVENT_FINALIZE = 'finalize';
export const TOURNAMENT_QUEUE_TIME_MS = 300 * 1000; // 5 minutes
export const TOURNAMENT_QUEUE_PERMISSIVE_MS = 5 * 1000; // 5 seconds

export const TOURNAMENT_STATUSES = {
  [TOURNAMENT_STATUS_IN_PROGRESS]: 'In Progress',
  [TOURNAMENT_STATUS_UPCOMING]: 'Upcoming',
  [TOURNAMENT_STATUS_COMPLETED]: 'Completed'
};

export const TOURNAMENT_LIST_EMPTY_TITLE = {
  [TOURNAMENT_STATUS_IN_PROGRESS]: 'No Tournaments In Progress',
  [TOURNAMENT_STATUS_UPCOMING]: 'No Upcoming Tournaments',
  [TOURNAMENT_STATUS_COMPLETED]: 'No Past Tournaments'
};

export const TOURNAMENT_LIST_EMPTY_SUBTEXT = {
  [TOURNAMENT_STATUS_UPCOMING]:
    "There aren't any upcoming Tournaments at the moment. Check back soon to join in the excitement!",
  [TOURNAMENT_STATUS_IN_PROGRESS]:
    "There aren't any Tournaments in progress at the moment. Check back soon to compete for great rewards!",
  [TOURNAMENT_STATUS_COMPLETED]:
    'Stay tuned for future Tournaments and join in the fun!'
};

export function isTournamentQueueAvailable(data, permissive = false) {
  if (!data) {
    return false;
  } else if (!(data instanceof Date)) {
    if (data.startTime) {
      data = data.startTime;
    }
    if (typeof data === 'string') {
      data = fromIso9075DateString(data);
    }
  }
  const earlyLimit =
    TOURNAMENT_QUEUE_TIME_MS +
    (permissive ? TOURNAMENT_QUEUE_PERMISSIVE_MS : 0);
  return TimeSync.toLocalTime(data) - Date.now() <= earlyLimit;
}
